// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Kwf","delete":"styles_delete__3NIOj","update":"styles_update__1SLwR","add":"styles_add__1KOCJ"};